// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"RJ-z","loadingMedia":"SJ-z","reviewsImagesAndVideos":"TJ-z","limitHeight":"UJ-z"};